import N from 'utils-support/navigation'
import SupportListWrapper from 'core/page/SupportListWrapper'
import { IExternalGMS } from '@cbgms/api'

import { listExternalGMS } from 'gms-support/src/app-support/external-gms/state/actions'

export const onAdd = () => {
  N.push('/external-gms/new')
}

export const onEdit = (data: { ExternalGMS: IExternalGMS }) => {
  N.push(`/external-gms/edit/${data.ExternalGMS.UUID}`)
}

const ExternalGMSList = () => {
  return (
    <SupportListWrapper
      scope='external-gms'
      type='external-gms-list'
      onAdd={onAdd}
      onEdit={onEdit}
      loadAction={listExternalGMS}
      translationKey='external_gms'
    />
  )
}

export default ExternalGMSList
